import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.SentimentFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'sentiment'
  facetName: 'sentiment'
  humanize: true
  addMissing: true
  selectAll: true

  old_initialize: ->
    super
    @searchQuery = @options.searchQuery
    @facets = []
    @_addSentimentIfNecessary(@facets, 0, 'negative')
    @_addSentimentIfNecessary(@facets, 1, 'neutral')
    @_addSentimentIfNecessary(@facets, 2, 'positive')
    @facet['sentiment'] = { terms: @facets, missing: @facet['sentiment']['missing'] }

  initialize: ->
    super
    @searchQuery = @options.searchQuery
    @facets = []
    _.each(['negative', 'neutral', 'positive'], (s) =>
      count = @options.facet['sentiment'][s]
      @facets.push({term: s, count: count}) if count > 0
    )
    @facet['sentiment'] = { terms: @facets, missing: @options.facet['sentiment']['no_sentiment'] }

  _addSentimentIfNecessary: (list, index, name) ->
    count = @options.facet['sentiment']['ranges'][index].count
    list.push({term: name, count: count}) if count > 0

  getAppliedValues: ->
    return @searchQuery.get('sentiment')

  addFilter: (value) ->
    @searchQuery.addSentiment(value)
